import styled from "styled-components";

export const BuyingBanner_Wrapper = styled.div`
background: ${props => props.bg ? props.bg : "linear-gradient(180deg, #FFEACA 0%, #FFD491 100.79%)"};
`

export const Banner_Heading = styled.h3`
color: ${props => props.color ? props.color : "#fff"};
font-size: 25px;
font-weight: 700;
line-height: normal;
margin-bottom: 10px;
letter-spacing: 1.6px;
  span.red {
    font-size: 33px;
    color: #ff6600;
    font-style: italic;
  }
  span.blue {
    font-size: 33px;
    color: #335da3;
    font-style: italic;
    margin-right: 3px;
  }
`

export const BannerContent_para = styled.p`
color: ${props => props.color ? props.color : "#fff"};
font-size: 16px;
// font-style: normal;
font-family: 'NotoSansKR-Medium';
line-height: normal;
margin-bottom: 0px;
  span {
    font-style: italic;
    margin-right: 3px;
  }
`
export const BtnTxt_Absolute = styled.p`
position: absolute;
top: 56%;
left: 32%;
color: #FFF;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
`
export const Banner_Back_Img = styled.img`
  width: 249px;
  height: 133px;
  margin: 25px 0px 0px 100px;
`

// export const Banner_Back_Img = styled.div`
//   background: url('/img/bg_stit.png') no-repeat;
//   background-position: 20px center;
//   background-size: cover; /* or contain */
//   width: 50%; 
//   height: auto;
// `
export const Banner_Img = styled.img`
// margin-left: -78px;
margin-left: -4px;
width: 208px;
height: 181px;
cursor: pointer
`
